import { useMutation, useQueryClient } from '@tanstack/react-query'
import { deleteInquiryRelatedDivision } from '@/lib'
import { queryKeys } from '@/lib/queryKeys'

export function useDeleteInquiryRelatedDivision(inquiryId: number) {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (relatedDivisionId: number) => {
      return deleteInquiryRelatedDivision(inquiryId, relatedDivisionId)
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.inquiries.all() })
      queryClient.invalidateQueries({ queryKey: queryKeys.inquiry.relatedDivisions(inquiryId) })
      queryClient.invalidateQueries({ queryKey: queryKeys.inquiry.actionLogs(inquiryId) })
      queryClient.invalidateQueries({ queryKey: queryKeys.inquiry.assignMembers.all() })
    },
  })
}
